// store.js

import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootReducer, { rootSaga } from "../reducers";
import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import persistReducer from "redux-persist/es/persistReducer";
// import { composeWithDevTools } from 'redux-devtools-extension';

export const sagaMiddleware = createSagaMiddleware();

// Redux Persist 구성 객체
const persistConfig = {
  key: "erody2.0", // 스토리지 키
  storage, // 사용할 스토리지 엔진
  blacklist: [
    "productSearch",
    "lostFound",
    "agreePrivacy",
    "registerLostItem",
    "afterServiceAgent",
    "promotion",
    "storeInfo",
    "storeStatus",
    "quickMenu",
    // "connectChatServer",
    "ticketClose",
    // "getBranches",
  ], // 특정 리듀서만 적용안하겠다
};

const persistedReducer = persistReducer(persistConfig, rootReducer); // Persisted Reducer 생성

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // 특정 액션 타입에서 비직렬화 값을 무시하도록 설정
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        // 특정 경로에서 비직렬화 값을 무시하도록 설정
        ignoredPaths: ["register"],
      },
    }).concat(sagaMiddleware),
  //   devTools: process.env.NODE_ENV !== 'production', // 개발 환경에서만 Redux DevTools를 사용합니다.
});

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export default store;
